<template>
  <ul v-if="questions.length > 0" class="list list-unstyled">
    <li v-for="(question, index) in questions" :key="question.id">
      {{ index + 1 }} - {{ question.text }}
      <span
        role="button"
        class="badge bg-warning"
        title="Editar Questão"
        @click="$emit('editQuestion', question.id)"
      >
        Editar
      </span>
      <ul class="list">
        <li v-for="answer in question.answers" :key="answer.id">
          <span :class="{ 'text-success': answer.isCorrect == 1 }">
            {{ answer.text }}
          </span>
        </li>
      </ul>
    </li>
  </ul>
  <p v-else class="text-center mb-0">
    Este curso não possui nenhuma questão cadastrada
  </p>
</template>

<script>
export default {
  name: 'ListQuestions',

  props: {
    questions: {
      type: Array,
      required: true,
    },
  },
}
</script>
